<script lang="js">
import { RouterLink } from 'vue-router';

export default {
    name: 'AppSidebar',
    data() {
        return {
            isDevelopment: process.env.NODE_ENV === "development",
        }
    },
    computed: {
        menuItems() {
            // Use different routes for development vs production
            if (this.isDevelopment) {
                return [
                    { name: "Dashboard", label: "Dashboard", icon: "bi bi-columns-gap", route: "/app" },
                    { name: "Academics", label: "Academics", icon: "bi bi-mortarboard-fill", route: "/app/academics" },
                    { name: "Resources", label: "Resources", icon: "bi bi-folder-fill", route: "/app/resources" },
                    { name: "Finance", label: "Finance", icon: "bi bi-credit-card", route: "/app/finance" },
                    { name: "Settings", label: "Settings", icon: "bi bi-gear-fill", route: "/app/settings" },
                ];
            } else {
                return [
                    { name: "Dashboard", label: "Dashboard", icon: "bi bi-columns-gap", route: "/dashboard" },
                    { name: "Academics", label: "Academics", icon: "bi bi-mortarboard-fill", route: "/academics" },
                    { name: "Resources", label: "Resources", icon: "bi bi-folder-fill", route: "/resources" },
                    { name: "Finance", label: "Finance", icon: "bi bi-credit-card", route: "/finance" },
                    { name: "Settings", label: "Settings", icon: "bi bi-gear-fill", route: "/settings" },
                ];
            }
        }
    },
    methods: {
        isActive(routePath) {
            return this.$route.path === routePath;
        },
    },
    mounted() { },
    components: { RouterLink },
    created: function () { }
}
</script>
<template>
  <div
    class="sidebar bg-light border-end d-none d-lg-flex flex-column align-items-center overflow-scroll"
    style="width: 140px; min-width: 140px; max-width: 140px"
  >
    <ul class="nav flex-column w-100 text-center">
      <li
        v-for="item in menuItems"
        :key="item.name"
        class="nav-item w-100 p-3"
        :class="{ active: $route.path === item.route }"
      >
        <RouterLink
          class="nav-link d-flex flex-column align-items-center text-dark"
          :to="item.route"
        >
          <i :class="item.icon + ' fs-4'"></i>
          <span class="small">{{ item.label }}</span>
        </RouterLink>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.sidebar {
  position: sticky;
  top: 0;
  height: 100vh;
  flex-shrink: 0;
}

.sidebar ul li.active {
  color: #fff !important;
  background-color: #181c1f !important;
}

.sidebar ul li.active i,
.sidebar ul li.active span {
  color: #fff !important;
}
</style>
